<div class="input-group input-group-sm">
  <input [id]="getId(item)" [attr.type]="item.MainElementList[0].Type" class="col q-input-border q-bo"
         aria-label="Small" attr.aria-describedby="{{getId(item)}}-btn"
         [disabled]="isDisabled(item)"
         [(ngModel)]="item.MainElementList[0].Value"
         [ngClass]="setClass(item)">
  <div *ngFor="let button of item?.MainElementList?.slice(1)" class="input-group-append">
    <button *ngIf="button.Type === 'BUTTON'"
            class="q-btn q-bo q-main p-0"
            (click)="OnButtonClicked(button, ModalBoCompteClientSurEntite);"
            [id]="button?.ID ? button?.ID : ''"
            [title]="button?.Tooltip ? button?.Tooltip : ''">
      <i class="{{button.Src}}"></i>
    </button>
  </div>
</div>



<ng-template #ModalBoCompteClientSurEntite let-modalBoCompteClientSurEntite>
  <div class="modal-header w-100">
    <h5 class="modal-title big-title" id="exampleModalLongTitle">Compte pour l'entité de facturation</h5>

    <button type="button" class="close" aria-label="Close" (click)="modalBoCompteClientSurEntite.close('CANCEL')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body overflow-auto">
    <div class="row">
      <div class="col-12">
      <button id="ImportBtn" class="q-btn q-main" (click)="Save(modalBoCompteClientSurEntite)">
        <i class="fas fa-save"></i>
      </button>
      </div>
    </div>
    <table *ngIf="!modalLoading" class="table table-striped table-hover table-condensed my-2">
      <thead>
        <tr class="q-bold">
          <th>Entité</th>
          <th>Compte pour l'entité de facturation</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let item of entites">
          <td>{{item.LabelEntite}}</td>
          <td><input [(ngModel)]="item.LabelCompte" class="q-input-border" /></td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="modalLoading" class="row q-c-main my-2 justify-content-center">
      <i class="fas fa-spin fa-spinner fa-pulse fa-5x"></i>
    </div>
  </div>
</ng-template>
